import { ThemeColorTokenNames, ThemeGradientsTokenNames } from './ThemeTokens'
import { ThemeTokensHelper } from './ThemeTokensHelper'

/**
 * Semantic colors using CSS variables to tap into the current theme. Include <ThemeProvider />
 * from nutshell-legacy or implement your own CSS-variable definitions that define tokens from
 * ThemeColorTokenNames and ThemeGradientsTokenNames.
 */
export const ThemeColors = ThemeTokensHelper.toCSSVars(ThemeColorTokenNames)
export const ThemeGradient = ThemeTokensHelper.toCSSVars(ThemeGradientsTokenNames)
